// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","sticky":"Header_sticky__XEZI7"};